import React from 'react'
import PropTypes from 'prop-types'
import Button from '@boltui/button'
import { bem } from '@argos/utils'

const cn = bem({ prefix: 'lc-', block: 'prechat-freeform' })

export class Freeform extends React.Component {
  static defaultProps = {
    className: () => {},
    regex: {},
    hasError: false,
  }

  static propTypes = {
    className: PropTypes.func,
    hasError: PropTypes.bool,
    id: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func,
    onSubmit: PropTypes.func,
    regex: PropTypes.shape({
      pattern: PropTypes.string,
      description: PropTypes.string,
    }),
    trackingCode: PropTypes.string,
    value: PropTypes.string,
  }

  constructor(props) {
    super(props)
    this.ref = React.createRef()
  }

  get submitPayload() {
    return {
      id: this.props.id,
      value: this.props.value,
      trackingCode: this.props.trackingCode,
    }
  }

  componentDidMount() {
    this.ref.current.focus()
  }

  handleSubmit = (evt) => {
    evt.preventDefault()
    this.props.onSubmit(this.submitPayload)
  }

  render() {
    const { id, className, regex, hasError, label, value, onChange } = this.props
    const { description } = regex
    return (
      <form
        className={`${cn('', id)} lc-controls__form lc-controls__form--with-seperator`}
        noValidate
        onSubmit={this.handleSubmit}>
        <label ref={this.ref}>
          <span aria-hidden className='lc-controls__label'>
            {label}
          </span>

          {description && (
            <span className={`lc-controls__desc ${hasError ? 'lc-controls__desc--error' : ''}`}>{description}</span>
          )}

          <input
            aria-required={false}
            aria-invalid={hasError}
            className={`form-group__input ${hasError ? 'form-group__input--error' : ''}`}
            data-test={className('input')}
            value={value}
            onChange={(evt) => {
              onChange(evt.target.value)
            }}
          />

          <Button full type='submit' data-test={className('submit')}>
            Continue
          </Button>
        </label>
      </form>
    )
  }
}

export default Freeform
